import { createSelector } from "reselect";
import { populationTalliesByLocationSelector } from "../population_tallies_by_location_selector";

export const populationTalliesByLocationLoadStateSelector = createSelector(
  populationTalliesByLocationSelector,
  tallies => tallies.loadState
);
